/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import * as styled from 'styled-components';
import {theme, paddings} from 'components/shared/theme';

interface IColumn {
  align?: string;
  size?: number;
  padding?: string;
}

const {
  mediaPhone,
  footerHeight
} = theme;

export const AppContainer = styled.default.div`
  margin: 3.5rem 0 ${footerHeight};
  height: calc(100vh - 3.5rem - ${footerHeight});
  overflow: auto;
  display: flex;
  overflow-x: hidden;
`;

export const Body = styled.default.div`
  width: 100%;
  margin: 1rem 0;
  padding: 0 ${paddings.xlarge};
  ${mediaPhone}{
    padding: ${paddings.small} ${paddings.medium};
  }
`;

export const Row = styled.default.div`
  display: flex;
`;

export const Column = styled.default.div<IColumn>`
  flex: ${({size}): number => size || 1};
  text-align: ${({align}): string => align || 'right'};
  ${({padding}) => padding && styled.css`
    padding: ${padding};
  `}
`;

export const Main = styled.default.div`
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0%;
  display: flex;
  top: 0%;
  align-items: center;
  justify-content: center;
`;